import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** CardBody is  */
const CardBody = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-card__body", className)} {...other}>
      {children}
    </div>
  );
};

CardBody.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

CardBody.defaultProps = {
  className: "",
  children: null
};

export default CardBody;
